module.exports = __webpack_public_path__ + "img/boson.2792398b.svg";